"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeDedupKey = void 0;
/**
 * Compose the Dedup_Key used to detect a previously imported record.
 *
 * The key is formed from the source-system reference and the import batch
 * identity as `${sourceRef}#${importBatchId}` (import Business Rule 2). Pure,
 * total function — callers are responsible for supplying stable inputs.
 */
function composeDedupKey(sourceRef, importBatchId) {
    return `${sourceRef}#${importBatchId}`;
}
exports.composeDedupKey = composeDedupKey;
